import Vue from "vue";
import moment from "moment";
moment.locale("id");
Vue.filter("parse", (value, id) => {
  if (id === null || id === undefined) return value;
  if (value === null || value === undefined) return value;
  let toReturn = "";
  if (id.search("-") === -1) {
    switch (id) {
      case "active":
        toReturn = value === "1" || value === 1 ? "Aktif" : "Non Aktif";
        break;
      case "scanned_status":
        toReturn = value === "1" || value === 1 || value ? "Berhasil" : "Gagal";
        break;
    case "grade":
        toReturn = value ? `Kelas ${value}` : "Semua Jenjang";
        break;
      case "member_type":
        toReturn = 
        value === "STUDENT" || value === 1
          ? "Siswa/i"
          : value === "TEACHER" || value === 2
          ? "Guru"
          : value === "EMPLOYEE" || value === 3
          ? "Karyawan"
          : "-";
        break;
      case "member_types":
        toReturn = 
        value === "students"
          ? "Siswa/i"
          : value === "teachers"
          ? "Guru"
          : value === "employees"
          ? "Karyawan"
          : "-";
        break;
      case "borrow_status": 
        toReturn = 
        value === "BORROW"
          ? "Pinjam"
          : value === "RETURN"
          ? "Kembali"
          : value === "LOST"
          ? "Hilang"
          : "-";
        break;
      case "borrow_status_color": 
        toReturn = 
        value === "BORROW"
          ? "warning"
          : value === "RETURN"
          ? "success"
          : value === "LOST"
          ? "danger"
          : "-";
        break;
      case "borrow_penalty_status": 
        toReturn = 
        value === "PAYED"
          ? "Sudah Dibayar"
          : value === "UNPAYED"
          ? "Belum Dibayar"
          : value === "DELETED"
          ? "Dihapuskan"
          : "-";
        break;
      case "is_done":
        toReturn = value === "1" || value === 1 ? "Selesai" : "Proses";
        break;
      case "is_exist":
        toReturn = value === "1" || value === 1 ? "Ada" : "Tidak Ada";
        break;
      case "print_status":
        toReturn =
          value === "1" || value === 1 ? "Sudah Dicetak" : "Belum Dicetak";
        break;
      case "status_approval":
        toReturn =
          value === "1" || value === 1
            ? "Disetujui"
            : value === "2" || value === 2
            ? "Ditolak"
            : "Menunggu";
        break;
      case "status_did":
        toReturn =
          value === "1" || value === 1
            ? "Sudah Dilakukan"
            : value === "2" || value === 2
            ? "Tidak Dilakukan"
            : "Belum Dilakukan";
        break;
      case "status_received":
        toReturn =
          value === "1" || value === 1 ? "Sudah Diterima" : "Belum Diterima";
        break;
      case "concat_buku":
        toReturn = (typeof parseInt(value) == 'number' ? Number(value).toLocaleString("id-ID") : value) + " Buku";
        break;
      case "concat_inch":
        toReturn = (typeof parseInt(value) == 'number' && parseInt(value) >= 0 ? Number(value).toLocaleString("id-ID") : value) + " Inch";
        break;
      case "concat_label":
        toReturn = (typeof parseInt(value) == 'number' && parseInt(value) >= 0 ? Number(value).toLocaleString("id-ID") : value) + " Label";
        break;
      case "status_user":
        toReturn = value === "user_active" ? "Aktif" : "Non Aktif";
        break;
      case "paid":
        toReturn = value === "1" || value === 1 ? "Lunas" : "Belum Lunas";
        break;
      case "status_overall":
        toReturn = value ? "Selesai" : "Belum Selesai";
        break;
      case "uppercase":
        toReturn = value.toUpperCase();
        break;
      case "allow":
        toReturn =
          value.toLowerCase() === "y" ? "DIperbolehkan" : "Tidak diizinkan";
        break;
      case "lock":
        toReturn = value.toLowerCase() === "y" ? "Close" : "Open";
        break;
      case "yn":
        toReturn = value.toLowerCase() === "y" ? "Ya" : "Tidak";
        break;
      case "prosen":
        toReturn = Number(value).toLocaleString("id-ID") + "%";
        break;
      case "s_komponen":
        toReturn = value + " Komponen";
        break;
      case "count_day":
        toReturn = value + " Hari";
        break;
      case "status_completed":
        toReturn =
          value === "1" || value === 1 ? "Sudah Selesai" : "Masih Proses";
        break;
      case "status_available":
        toReturn =
          value == "available"
            ? "Tersedia"
            : value == "not_available"
            ? "Tidak Tersedia"
            : "-";
        break;
      case "verify":
        if (value === "revision_request") toReturn = "Permintaan Revisi";
        else if (value === "verification_request") {
          toReturn = "Pengajuan Verifikasi";
        } else if (value === "appraisal_request") {
          toReturn = "Permintaan Penilaian";
        } else if (value === "approved") toReturn = "Disetujui";
        else toReturn = "Draft";
        break;
      case "number":
        toReturn = !isNaN(value) ? Number(value).toLocaleString("id") : value;
        break;
      case "number2fraction":
        toReturn = !isNaN(value)
          ? Number(value).toLocaleString("id", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
          : value;
        break;
      case "money":
        toReturn = !isNaN(value)
          ? "Rp. " + Number(value).toLocaleString("id")
          : value;
        break;
      case "date":
        if (value) toReturn = moment(value).format("DD MMMM YYYY");
        else toReturn = value
        break;
      case "longDate":
        if (moment(value, "YYYY-MM-DD", true).isValid()) {
          toReturn = moment(value).format("LL");
        } else toReturn = value;
        break;
      case "longDateTime":
        toReturn = moment(value).format('dddd, MMMM Do YYYY, HH:mm:ss a');
        break;
      case "longDateTime+7":
        toReturn = moment(value).add(7, 'h').format('dddd, MMMM Do YYYY, HH:mm:ss a');
        break;
      case "longDateTimeFromUtc":
        toReturn = moment(value).add(7, 'h').format('dddd, MMMM Do YYYY, HH:mm:ss a');
        break;
      case "dateTime":
        var str = value;
        var date = moment(str);
        // var dateComponent = date.utc().format("DD MMMM YYYY");
        // var timeComponent = date.utc().format("HH:mm");
        var dateComponent = date.format("DD MMMM YYYY");
        var timeComponent = date.format("HH:mm");
        toReturn = dateComponent + ", " + timeComponent;
        break;
      case "dateTime+7":
        var str = value;
        var date = moment(str).add(7, 'h');
        // var dateComponent = date.utc().format("DD MMMM YYYY");
        // var timeComponent = date.utc().format("HH:mm");
        var dateComponent = date.format("DD MMMM YYYY");
        var timeComponent = date.format("HH:mm");
        toReturn = dateComponent + ", " + timeComponent;
        break;
      case "period":
        if (moment(value, "YYYY-MM-DD", true).isValid()) {
          toReturn = moment(value).format("MMMM YYYY");
        } else toReturn = value;
        break;
      case "year":
        if (moment(value, "YYYY-MM-DD", true).isValid()) {
          toReturn = moment(value).format("YYYY");
        } else toReturn = moment(value).format("YYYY");
        break;
      case "hours":
        let parsed = value.split(":");
        parsed[0] = Number(parsed[0]) > 0 ? Number(parsed[0]) + " Jam" : null;
        parsed[1] = Number(parsed[1]) > 0 ? Number(parsed[1]) + " Menit" : null;
        parsed[2] = Number(parsed[2]) > 0 ? Number(parsed[2]) + " Detik" : null;
        toReturn = parsed.filter(x => x).join(", ");
        break;
      case "time":
        toReturn = moment(value, "HH:mm:ss").format("LTS a");
        break;
      case "kelamin":
        toReturn = value.toLowerCase() === "male" ? "Laki-Laki" : "Perempuan";
        break;
      case "gender":
        toReturn = value.toLowerCase() === "L" ? "Laki-Laki" : "Perempuan";
        break;
      case "kawin":
        if (value === "single") toReturn = "Belum Menikah";
        else if (value === "married") toReturn = "Menikah";
        else if (value === "widow") toReturn = "Janda/Duda";
        else toReturn = "Tidak Diketahui";
        break;
      case "status_code":
        toReturn = value
          .toLowerCase()
          .split("_")
          .map(
            kebab =>
              kebab
                .toLowerCase()
                .charAt(0)
                .toUpperCase() + kebab.slice(1)
          )
          .join(" ");
        break;
      case "sync":
        toReturn =
          value === "not_synchronized_yet"
            ? "Belum di Sinkronkan"
            : "Sudah di Sinkronkan";
        break;
      case "finished":
        toReturn = value === "finished" ? "Sudah Selesai" : "Belum Selesai";
        break;
      case "cm":
        toReturn = value + " cm";
        break;
      case "CmToM":
        if (value) {
          toReturn = (parseFloat(value) * 0.01).toFixed(2) + " m";
        } else {
          toReturn = null;
        }
        break;
      case "rainfall":
        toReturn = value + " mm";
        break;
      case "humidity":
        toReturn = value + " %";
        break;
      case "temperature":
        toReturn = value + " °C";
        break;
      case "progressVariant":
        const progress = parseInt(value)
        if (progress < 50) toReturn = 'danger'
        else if (progress < 75) toReturn = 'warning'
        else if (progress <= 100) toReturn = 'success'
        else toReturn = 'success'
        break
      default:
        toReturn = value;
    }
  } else {
    switch (id.split("-")[0]) {
      case "prefix":
        toReturn = id.split("-")[1] + " " + value;
        break;
      case "suffix":
        toReturn = value + " " + id.split("-")[1];
        break;
      default:
        toReturn = value;
    }
  }
  return toReturn;
});
export default {
  name: "filterTemplate"
};



// WEBPACK FOOTER //
// ./src/utils/filter.js